import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0babe5c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-desc" }
const _hoisted_2 = {
  key: 0,
  class: "desc-title"
}
const _hoisted_3 = { class: "desc-content" }
const _hoisted_4 = ["innerHTML"]

interface Props {
  title?: string;
  value: Array<string>;
  startWithLine?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    value: { default: () => [] },
    startWithLine: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["desc-row", { 'start-with-line': __props.startWithLine }]),
          innerHTML: item
        }, null, 10, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})